import moment from "moment";
import { httpApi } from "api/http.api";
import { IModuleList, IPermissionResponse, Permissions, PermissionsRequest, PermissionsResponse } from "domain/Permissions";
import { AxiosResponse } from "axios";

/**
 *
 * @returns Vehicles[]
 */
export const getPermissionsList = (): Promise<IPermissionResponse> =>
  httpApi.get<IPermissionResponse>("Roles").then(({ data }) => data);

export const getModulesList = (): Promise<IModuleList> =>
  httpApi.get<IModuleList>("Roles/GetModules").then(({ data }) => data);

export const addPermissions = (
  garmentsPayload: PermissionsRequest
): Promise<PermissionsResponse> =>
  httpApi
    .post<PermissionsResponse>("Roles/AddRole", {
      ...garmentsPayload,
    })
    .then(({ data }) => data);

export const updatePermissions = (
  id: string,
  permissionsPayload: PermissionsRequest
): Promise<PermissionsResponse> =>
  httpApi
    .put<PermissionsRequest>("Roles/UpdateRole/" + id, {
      ...permissionsPayload,
    })
    .then(({ data }) => data);

export const getPermissionById = (id: string): Promise<Permissions> =>
  httpApi
    .get<IPermissionResponse>(`Roles/${id}`)
    .then(({ data }) => data["data"][0])
    .then((data) => data);

export const deletePermissions = async (id: string): Promise<PermissionsResponse> => {
  let time = moment().toISOString();

  let hmac_token: AxiosResponse<PermissionsResponse> = await httpApi.delete<PermissionsResponse>(
    `Roles/DeleteRole`,
    {
      params: { role_id: id },
      data: { hmac_time: time },
    }
  );

  let response: AxiosResponse<PermissionsResponse> = await httpApi.delete<PermissionsResponse>(
    `Roles/DeleteRole`,
    {
      params: { role_id: id },
      data: { hmac_time: time, hmac: hmac_token.data.hmac },
    }
  );

  return response.data;
};
